export const overviewComponents = [{
    name: '动力',
    component: 'comprehensive_situation/DeviceTotal',
    height: '170px',
    position: [{
        tag: 'power_category_tag',
        direction: 'left',
        sort: 1,
        display: true
      }, {
        tag: 'environment_category_tag',
        direction: 'left',
        sort: 1,
        display: true
      }, {
        tag: 'security_category_tag',
        direction: 'left',
        sort: 1,
        display: true
      }, {
        tag: 'fire_category_tag',
        direction: 'left',
        sort: 1,
        display: true
      },
      {
        tag: 'water_category_tag',
        direction: 'left',
        sort: 1,
        display: true
      }
    ],
  }, {
    name: '设备分布',
    component: 'Infrastructure',
    height: '227px',
    label: false,
    position: [{
        tag: 'power_category_tag',
        direction: 'left',
        sort: 2,
        display: true
      }, {
        tag: 'environment_category_tag',
        direction: 'left',
        sort: 2,
        display: true
      }, {
        tag: 'security_category_tag',
        direction: 'left',
        sort: 2,
        display: true
      }, {
        tag: 'fire_category_tag',
        direction: 'left',
        sort: 2,
        display: true
      },
      {
        tag: 'water_category_tag',
        direction: 'left',
        sort: 2,
        display: true
      }
    ],
  },
  {
    name: '能效',
    component: 'comprehensive_situation/EnergyEfficiency',
    height: '115px',
    hideInAll: true,
    position: [{
      tag: 'power_category_tag',
      direction: 'left',
      sort: 3,
      display: true
    }],
  }, {
    name: '机柜信息',
    component: 'comprehensive_situation/cabinetInfo',
    height: '270px',
    label: false,
    hideInAll: true,
    position: [{
      tag: 'power_category_tag',
      direction: 'left',
      sort: 3,
      display: true
    }],
  },{
    name: 'ups/电表',
    component: 'PowerDevice',
    height: '300px',
    label: false,
    hideInAll: true,
    position: [{
      tag: 'power_category_tag',
      direction: 'left',
      sort: 4,
      display: true
    }],
  },
  {
    name: '配电柜',
    component: 'PowerDistributionCabinet',
    height: '300px',
    label: false,
    position: [{
      tag: 'power_category_tag',
      direction: 'left',
      sort: 4,
      display: true
    }],
  },
  {
    name: '配电柜电表',
    component: 'CabinetElectricity',
    height: '300px',
    label: false,
    position: [{
      tag: 'power_category_tag',
      direction: 'left',
      sort: 4,
      display: true
    }],
  },
  {
    name: 'UPS',
    component: 'UPSThreePhaseVoltage',
    height: '300px',
    label: false,
    position: [{
      tag: 'power_category_tag',
      direction: 'left',
      sort: 4,
      display: true
    }],
  },
  {
    name: '机柜数量',
    component: 'CabinetDeviceTotal',
    height: '170px',
    hideInAll: true,
    position: [{
      tag: 'power_category_tag',
      direction: 'left',
      sort: 1,
      display: true
    }],
  },
  {
    name: '温湿度',
    component: 'TemperatureHumidity',
    height: '435px',
    label: false,
    position: [{
      tag: 'environment_category_tag',
      direction: 'left',
      sort: 3,
      display: true
    }],
  },
  {
    name: '视频监控',
    component: 'comprehensive_situation/Video',
    height: '435px',
    position: [{
      tag: 'security_category_tag',
      direction: 'left',
      sort: 3,
      display: true
    }],
  },
  {
    name: '消防烟感',
    component: 'comprehensive_situation/Smoke',
    height: '435px',
    position: [{
      tag: 'fire_category_tag',
      direction: 'left',
      sort: 3,
      display: true
    }],
  }, {
    name: '告警趋势',
    component: 'AlarmTrend',
    height: '247px',
    label: false,
    position: [{
      tag: 'power_category_tag',
      direction: 'right',
      sort: 1,
      display: true
    }, {
      tag: 'environment_category_tag',
      direction: 'right',
      sort: 1,
      display: true
    }, {
      tag: 'fire_category_tag',
      direction: 'right',
      sort: 1,
      display: true
    }, {
      tag: 'water_category_tag',
      direction: 'right',
      sort: 1,
      display: true
    }, {
      tag: 'security_category_tag',
      direction: 'right',
      sort: 1,
      display: true
    }],
  },
  {
    name: '设备告警',
    component: 'comprehensive_situation/DeviceAlarm',
    height: '270px',
    position: [{
      tag: 'power_category_tag',
      direction: 'right',
      sort: 2,
      display: true
    }, {
      tag: 'environment_category_tag',
      direction: 'right',
      sort: 2,
      display: true
    }, {
      tag: 'fire_category_tag',
      direction: 'right',
      sort: 2,
      display: true
    }, {
      tag: 'water_category_tag',
      direction: 'right',
      sort: 2,
      display: true
    }, {
      tag: 'security_category_tag',
      direction: 'right',
      sort: 2,
      display: true
    }],
  },
  {
    name: '多回路',
    component: 'comprehensive_situation/MultiLoop',
    height: '315px',
    position: [{
      tag: 'power_category_tag',
      direction: 'right',
      sort: 3,
      display: true
    }],
  },
  {
    name: '空调温湿度',
    component: 'comprehensive_situation/AirConditioner',
    height: '315px',
    position: [{
      tag: 'environment_category_tag',
      direction: 'right',
      sort: 3,
      display: true
    }],
  },
  {
    name: '磁悬浮内机',
    component: 'comprehensive_situation/VentilationWall',
    height: '315px',
    position: [{
      tag: 'environment_category_tag',
      direction: 'right',
      sort: 4,
      display: true
    }],
  },
  {
    name: '门禁',
    component: 'comprehensive_situation/Door',
    height: '450px',
    hideInAll: true,
    position: [{
      tag: 'security_category_tag',
      direction: 'right',
      sort: 1,
      display: true
    }],

  },
  {
    name: '电梯运行统计',
    component: 'comprehensive_situation/Elevator',
    height: '872px',
    hideInAll: true,
    position: [{
      tag: 'elevator_category_tag',
      direction: 'right',
      sort: 1,
      display: true
    }],

  },
  {
    name: '电梯监控',
    component: 'comprehensive_situation/ElevatorVideo',
    height: '410px',
    hideInAll: true,
    position: [{
      tag: 'elevator_category_tag',
      direction: 'left',
      sort: 3,
      display: true
    }],

  },
  {
    name: '故障统计',
    component: 'ElevatorStatistics',
    height: '190px',
    hideInAll: true,
    position: [{
      tag: 'elevator_category_tag',
      direction: 'left',
      sort: 2,
      display: true
    }],

  },
  {
    name: '电梯总览',
    component: 'comprehensive_situation/ElevatorTotal',
    height: '180px',
    hideInAll: true,
    position: [{
      tag: 'elevator_category_tag',
      direction: 'left',
      sort: 1,
      display: true
    }],

  },
  // 停车场数据面板
  {
    name: '停车场实时总览',
    component: 'park_system/ParkOverview',
    height: '192px',
    hideInAll: true,
    position: [{
      tag: 'synthesize_category_tag',
      direction: 'left',
      sort: 8,
      display: true
    }],
  },
  {
    name: '车辆进场统计',
    component: 'park_system/CarEnterRecord',
    height: '330px',
    hideInAll: true,
    position: [{
      tag: 'synthesize_category_tag',
      direction: 'left',
      sort: 9,
      display: true
    }],
  },
  {
    name: '车辆出场统计',
    component: 'park_system/CarLeaveRecord',
    height: '330px',
    hideInAll: true,
    position: [{
      tag: 'synthesize_category_tag',
      direction: 'left',
      sort: 10,
      display: true
    }],
  },
  {
    name: '道闸设备',
    component: 'park_system/CarAccessMonitoring',
    height: '961px',
    hideInAll: true,
    position: [{
      tag: 'synthesize_category_tag',
      direction: 'right',
      sort: 8,
      display: true
    }],
  },
  {
    name: '收费记录',
    component: 'park_system/ParkingTemporaryPay',
    height: '600px',
    hideInAll: true,
    position: [{
      tag: 'synthesize_category_tag',
      direction: 'left',
      sort: 10,
      display: true
    }],
  },
  {
    name: '水位监测',
    component: 'comprehensive_situation/WaterLevel',
    height: '305px',
    hideInAll: true,
    position: [{
      tag: 'water_category_tag',
      direction: 'left',
      sort: 3,
      display: true
    }],
  },
  {
    name: '压力变速器',
    component: 'comprehensive_situation/Pressure',
    height: '305px',
    hideInAll: true,
    position: [{
      tag: 'water_category_tag',
      direction: 'left',
      sort: 3,
      display: true
    }],
  },
  {
    name: '水阀监测',
    component: 'comprehensive_situation/WaterValveMonitoring',
    height: '482px',
    hideInAll: true,
    position: [{
      tag: 'water_category_tag',
      direction: 'left',
      sort: 4,
      display: true
    }],
  },
  {
    name: '水质监测',
    component: 'comprehensive_situation/WaterMonitoring',
    height: '482px',
    hideInAll: true,
    position: [{
      tag: 'water_category_tag',
      direction: 'left',
      sort: 5,
      display: true
    }],
  },
  {
    name: '智能仪表配电柜',
    component: 'IIPDCDevice',
    height: '300px',
    position: [{
      tag: 'power_category_tag',
      direction: 'left',
      sort: 1,
      display: true
    }],
  },
  {
    name: '精密配电柜',
    component: 'PPDCSDevice',
    height: '400px',
    position: [{
      tag: 'power_category_tag',
      direction: 'left',
      sort: 1,
      display: true
    }],
  },
  {
    name:"红外模块",
    component: 'IRModuleDevice',
    height: '160px',
    position: [{
      tag: 'security_category_tag',
      direction: 'left',
      sort: 1,
      display: true
    }],
  }
]
